<template>
  <fragment>
    <ExpansionPanelFilters class="my-4">
      <v-form
        ref="form"
        @submit.prevent="filterPointOfSale"
        class="search-forms"
      >
        <v-row>
          <v-col cols="12" md="3" sm="4">
            <BaseTextField
              v-model="filter.pesquisar"
              :placeholder="$t('reports.search')"
              @input="handleSearch"
              append-icon="mdi-magnify"
              single-line
              hide-details
              clearable
            ></BaseTextField>
          </v-col>
          <v-col cols="12" md="3" sm="4">
            <BaseSelect
              v-model="filter.paymentMethod"
              :label="$t('reports.payment-method.input')"
              :placeholder="$t('reports.payment-method.select')"
              :no-data-text="$t('reports.no-info-found')"
              :items="paymentMethods"
              item-text="key"
              item-value="value"
              clearable
              @click:clear="filter.paymentMethod = ''"
            />
          </v-col>
          <v-col cols="12" md="3" sm="4" v-if="!idProduto">
            <BaseAutocomplete
              v-model="filter.event"
              :label="$t('reports.sales-by-event.event')"
              :placeholder="$t('reports.sales-by-event.select')"
              :no-data-text="$t('reports.sales-by-event.no-events-found')"
              :items="allEvents"
              :loading="salesByPointOfSaleLoading"
              item-text="descricao"
              item-value="idproduto"
              clearable
              @click:clear="filter.event = ''"
            />
          </v-col>
          <v-col cols="12" md="3" sm="4">
            <date-time-picker
              :label="$t('reports.initial-date')"
              @formatted-date="handleInitDateTime"
            ></date-time-picker>
          </v-col>

          <v-col cols="12" md="3" sm="4">
            <date-time-picker
              :label="$t('reports.final-date')"
              @formatted-date="handleEndDateTime"
            ></date-time-picker>
          </v-col>

          <v-col class="d-flex justify-end">
            <BaseButton
              type="submit"
              :loading="salesByPointOfSaleLoading"
              variant="filter"
              class="button rounded-xxl"
            >
              {{ $t("reports.filter") }}
            </BaseButton>
          </v-col>
        </v-row>
      </v-form>
    </ExpansionPanelFilters>

    <v-data-table
      class="rounded-lg"
      :no-data-text="$t('reports.no-info-found')"
      :loading-text="$t('reports.loading-info')"
      :loading="salesByPointOfSaleLoading"
      :headers="headers"
      :items="allSalesByPointOfSale.info"
      :items-per-page="10"
      mobile-breakpoint="0"
      :header-props="{
        class: 'rounded-t-lg',
        color: $config.dados.corinputs,
      }"
      :footer-props="{
        class: 'rounded-b-lg',
        itemsPerPageOptions: [10, 20, 50],
        itemsPerPageText: $t('reports.sales-per-page'),
      }"
    >
      <template v-slot:item.debito="{ item }">
        {{ item.debito | moeda }}
      </template>
      <template v-slot:item.credito="{ item }">
        {{ item.credito | moeda }}
      </template>
      <template v-slot:item.dinheiro="{ item }">
        {{ item.dinheiro | moeda }}
      </template>
      <template v-slot:item.pix="{ item }">
        {{ item.pix | moeda }}
      </template>
      <template v-slot:item.valor_total="{ item }">
        {{ item.valor_total | moeda }}
      </template>
      <template v-slot:item.action="{ item }">
        <div style="display: flex; justify-content: center; gap: 1.7rem">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :color="$config.dados.corinputs"
                height="15"
                width="15"
                small
                icon
                v-bind="attrs"
                v-on="on"
                @click="openDialog(item.idequipamento)"
              >
                <v-icon>mdi-table-large</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("reports.point-of-sale.details") }}</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :color="$config.dados.corinputs"
                height="15"
                width="15"
                icon
                v-bind="attrs"
                v-on="on"
                :loading="loadingExportDetailsCSV == item.idequipamento"
                @click="exportDetailsCSV(item.idequipamento)"
              >
                <v-icon>mdi-microsoft-excel</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("reports.point-of-sale.export-details") }}</span>
          </v-tooltip>

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :color="$config.dados.corinputs"
                height="15"
                width="15"
                icon
                v-bind="attrs"
                v-on="on"
                :loading="loadingExportDetailsPDF == item.idequipamento"
                @click="exportDetailsPDF(item.idequipamento)"
              >
                <v-icon>mdi-file-pdf-box</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("reports.point-of-sale.export-details") }}</span>
          </v-tooltip>
        </div>
      </template>

      <template
        v-for="(totais, index) in allSalesByPointOfSale.totals"
        v-slot:body.append
      >
        <tr :key="index" class="text-end font-weight-bold total-row">
          <td class="text-start">Total</td>
          <td>{{ totais.qtd_ingressos }}</td>
          <td>{{ totais.qtd_cortesias }}</td>
          <td>{{ formatCurrency(totais.debito) || "R$ 0,00" }}</td>
          <td>{{ formatCurrency(totais.credito) || "R$ 0,00" }}</td>
          <td>{{ formatCurrency(totais.pix) || "R$ 0,00" }}</td>
          <td>{{ formatCurrency(totais.dinheiro) || "R$ 0,00" }}</td>
          <td>{{ formatCurrency(totais.valor_total) || "R$ 0,00" }}</td>
          <v-spacer></v-spacer>
        </tr>
      </template>
    </v-data-table>
    <SaleByPointOfSaleDetails
      :equipment="equipment"
      :dialog="pointOfSaleDialog"
      @close="pointOfSaleDialog = false"
    />
  </fragment>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import dayjs from "dayjs";
import _ from "lodash";
import { formatCurrency } from "@/utils";

import BaseSelect from "@/components/forms/BaseSelect.vue";
import BaseTextField from "@/components/forms/BaseTextField.vue";
import BaseAutocomplete from "@/components/forms/BaseAutocomplete.vue";
import BaseButton from "@/components/forms/BaseButton.vue";
import DateTimePicker from "@/components/forms/DateTimePicker.vue";
import SaleByPointOfSaleDetails from "./SalesByPointOfSaleDetail.vue";
import ExpansionPanelFilters from "@/components/forms/ExpansionPanelFilters.vue";
export default {
  name: "SalesByPointOfSale",
  components: {
    BaseSelect,
    BaseTextField,
    BaseAutocomplete,
    BaseButton,
    DateTimePicker,
    SaleByPointOfSaleDetails,
    ExpansionPanelFilters,
  },
  data() {
    return {
      formatCurrency,
      pointOfSaleDialog: false,
      equipment: "",
      loadingExportDetailsCSV: "",
      loadingExportDetailsPDF: "",
      filter: {
        pesquisar: "",
        pointOfSale: "",
        event: "",
        paymentMethod: "",

        initDateTime: "",
        endDateTime: "",
      },
      dayjs: dayjs,
    };
  },
  computed: {
    ...mapGetters([
      "allEvents",
      "allSalesByPointOfSale",
      "equipments",
      "idProduto",
      "intervalDates",
      "paymentMethods",
      "pointOfSales",
      "salesByPointOfSaleLoading",
      "storeSequencial",
    ]),
    headers() {
      return [
        {
          text: this.$t("reports.point-of-sale.equipment"),
          align: "start",
          sortable: false,
          value: "equipamento",
          width: 180,
        },
        {
          text: this.$t("reports.point-of-sale.sold-tickets"),
          align: "end",
          value: "qtd_ingressos",
          width: 170,
        },
        {
          text: this.$t("reports.point-of-sale.generated-courtesies"),
          align: "end",
          value: "qtd_cortesias",
          width: 160,
        },
        {
          text: this.$t("reports.point-of-sale.debit"),
          align: "end",
          value: "debito",
          width: 175,
        },
        {
          text: this.$t("reports.point-of-sale.credit"),
          align: "end",
          value: "credito",
          width: 175,
        },
        {
          text: "Pix",
          align: "end",
          value: "pix",
          width: 100,
        },
        {
          text: this.$t("reports.point-of-sale.cash"),
          align: "end",
          value: "dinheiro",
          width: 150,
        },
        {
          text: this.$t("reports.grand-total"),
          align: "end",
          value: "valor_total",
          width: 200,
        },
        {
          text: this.$t("reports.point-of-sale.details"),
          align: "center",
          value: "action",
          sortable: false,
          width: 100,
        },
      ];
    },
  },
  methods: {
    ...mapActions([
      "fetchEquipmentOptions",
      "fetchEvents",
      "fetchPaymentMethodOptions",
      "fetchPointOfSaleOptions",
      "fetchSalesByPointOfSale",
      "exportSalesByPOSDetailCSV",
      "exportSalesByPOSDetailPDF",
    ]),
    ...mapMutations(["setSalesByPointOfSaleLoading", "setReportsFilter"]),
    filterPointOfSale() {
      this.setSalesByPointOfSaleLoading(true);
      let filter = {};

      if (this.filter.initDateTime) {
        Object.assign(filter, {
          dthr_ped_ini: this.filter.initDateTime,
        });
      }

      if (this.filter.endDateTime) {
        Object.assign(filter, {
          dthr_ped_fim: this.filter.endDateTime,
        });
      }

      if (this.filter.event) {
        Object.assign(filter, {
          idproduto: this.filter.event,
        });
      }

      if (this.idProduto) {
        Object.assign(filter, {
          idproduto: this.idProduto,
        });
      }

      Object.assign(filter, {
        producerId: this.storeSequencial,
        forma_pagamento: this.filter.paymentMethod,
        idponto_venda: this.filter.pointOfSale,
        pesquisar: this.filter.pesquisar,
      });

      this.setReportsFilter(filter);
      this.fetchSalesByPointOfSale(filter);
    },
    handleSearch: _.debounce(function (event) {
      this.filter.pesquisar = event;
      this.filterPointOfSale();
    }, 500),
    handleInitDateTime(formatteddatetime) {
      this.filter.initDateTime = formatteddatetime;
    },
    handleEndDateTime(formatteddatetime) {
      this.filter.endDateTime = formatteddatetime;
    },
    openDialog(id) {
      this.pointOfSaleDialog = true;
      this.equipment = id;
    },
    async exportDetailsCSV(equipmentId) {
      this.loadingExportDetailsCSV = equipmentId;

      await this.exportSalesByPOSDetailCSV({
        producerId: this.storeSequencial,
        getItems: true,
        idequipamento: equipmentId,
        dthr_ped_ini: this.filter.initDateTime,
        dthr_ped_fim: this.filter.endDateTime,
        forma_pagamento: this.filter.paymentMethod,
        idproduto: this.filter.event,
      });

      this.loadingExportDetailsCSV = "";
    },
    async exportDetailsPDF(equipmentId) {
      this.loadingExportDetailsPDF = equipmentId;

      await this.exportSalesByPOSDetailPDF({
        producerId: this.storeSequencial,
        getItems: true,
        idequipamento: equipmentId,
        dthr_ped_ini: this.filter.initDateTime,
        dthr_ped_fim: this.filter.endDateTime,
        forma_pagamento: this.filter.paymentMethod,
        idproduto: this.filter.event,
      });

      this.loadingExportDetailsPDF = "";
    },
  },
  watch: {
    "filter.pointOfSale"(e) {
      if (e) {
        this.fetchEquipmentOptions(e);
      }
    },
  },
  mounted() {
    this.fetchPointOfSaleOptions(this.storeSequencial);
    this.fetchPaymentMethodOptions();
    this.filterPointOfSale();
    this.fetchEvents({ producerId: this.storeSequencial });
  },
  destroyed() {
    this.filter = {
      pesquisar: "",
      pointOfSale: "",
      paymentMethod: "",
      initDateTime: "",
      endDateTime: "",
    };
  },
};
</script>
<style scoped></style>
